import React from "react";
import { Popconfirm, Tooltip } from "antd";
import { Button } from "antd";

const DeleteAdUnitsButton = ({ disabled, onDelete, label = "Delete" }) => (
  <Popconfirm
    placement="topLeft"
    title="Are you sure you want to delete the selected creative(s)? This action cannot be undone."
    onConfirm={onDelete}
    okText="Delete"
    cancelText="Cancel"
    overlayClassName="creative-popconfirm"
    okButtonProps={{}}
    cancelButtonProps={{}}
  >
    <Tooltip placement="bottom" title="Delete creative">
      <Button type="default" danger disabled={disabled}>
        {label}
      </Button>
    </Tooltip>
  </Popconfirm>
);

export default DeleteAdUnitsButton;
